module.exports = __webpack_public_path__ + "img/man.23551041.png";